import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { RetailerService } from '../api/retailer.service';
import { IActiveStaffsFilter, IPasswordCheck } from '../model/IActiveStaffsFilter';
import { IFindShopperByEmailRequest } from '../model/IFindShopperByEmailRequest';
import { IPagingResultShopperStaffDiscountItem } from '../model/IPagingResultShopperStaffDiscountItem';
import { IPagingResultShopperStaffDiscountTransactionListItem } from '../model/IPagingResultShopperStaffDiscountTransactionListItem';
import { IShopperInfo, IShopperStaff } from '../model/IShopperInfo';
import { IShopperStaffDiscountCreate } from '../model/IShopperStaffDiscountCreate';
import { IShopperStaffDiscountEdit } from '../model/IShopperStaffDiscountEdit';
import { IShopperStaffDiscountTransactionFilter } from '../model/IShopperStaffDiscountTransactionFilter';
import { IShopperStaffDiscountTransaction } from '../model/IShopperStaffDiscountTransactionItem';
import { IShopperStaffDiscountTransactionStatus } from '../model/IShopperStaffDiscountTransactionListItem';
import { IShopperStaffDiscountTransactionsSummary } from '../model/IShopperStaffDiscountTransactionsSummary';

export class DiscountForStaffService {
    public static $inject = ['http', 'retailerService', '$localStorage', '$uibModal', '$timeout' ];

    protected accessKey: string = 'mayModify';
    protected destroyTimeout: any;

    constructor(
        private http: HttpService,
        private retailerService: RetailerService,
        private $localStorage: ngStorage.StorageService,
        public $uibModal: ng.ui.bootstrap.IModalService,
        public $timeout: ng.ITimeoutService
    ) { }

    public getActiveStaffs(query: IActiveStaffsFilter) {
        return this.http.get<IPagingResultShopperStaffDiscountItem>(this.retailerService.shopperStaffs(), {params: query});
    }

    public createStaff(query: IShopperStaffDiscountCreate) {
        return this.http.post<number>(this.retailerService.createStaffDiscount(), query);
    }

    public getStaff(discountID: number) {
        return this.http.get<IShopperStaff>(this.retailerService.editStaffDiscount(discountID));
    }

    public editStaff(discountID: number, query: IShopperStaffDiscountEdit) {
        return this.http.put(this.retailerService.editStaffDiscount(discountID), query);
    }

    public findStaffByEmail(query: IFindShopperByEmailRequest) {
        return this.http.get<IShopperInfo>(this.retailerService.findStaff(), {params: query});
    }

    public getTransactionsWithDiscount(query: IShopperStaffDiscountTransactionFilter) {
        return this.http.get<IPagingResultShopperStaffDiscountTransactionListItem>(this.retailerService.allTransactionsHistory(), {params: query});
    }

    public getTransaction(transactionID: number) {
        return this.http.get<IShopperStaffDiscountTransaction>(this.retailerService.transactionHistory(transactionID));
    }

    public getTransactionsSummary(query: IShopperStaffDiscountTransactionFilter) {
        return this.http.get<IShopperStaffDiscountTransactionsSummary>(this.retailerService.transactionsHistorySummary(), {params: query});
    }

    public archiveStaff(discountID: number) {
        return this.http.delete(this.retailerService.archiveStaff(discountID));
    }

    public async checkAccess(): Promise<boolean> {
        if (this.$localStorage[this.accessKey]) {
            return true;
        } else {
            const operationResult: any = await this.$uibModal.open({
                component: 'discountForStaffConfirmPassword',
                resolve: {},
                backdrop: 'static',
                size: 'sm',
                windowClass: 'modal360 password-modal',
            }).result;
            if (operationResult === 'ok') {
                this.$localStorage[this.accessKey] = true;
                this.destroyTimeout = this.$timeout(
                    () => this.deleteAccessKey(),
                    360000
                );
                return true;
            }
        }
        return false;
    }

    public deleteAccessKey() {
        delete this.$localStorage[this.accessKey];
        this.$timeout.cancel(this.destroyTimeout);
    }

    public async checkPassword(password: IPasswordCheck): Promise<boolean> {
        return this.http.post<boolean>(this.retailerService.checkPassword(), password);
    }

}

angular
    .module('naut')
    .service('discountForStaffService', DiscountForStaffService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/discountForStaff/discount-for-staff.service.ts